<template>
    <div>
        <modal-dialog title="Get your delivery estimate" classes="modal--centered" :show="show" @close="show = false">
            <div class="text-center">
                <p>Enter your postcode to get an accurate delivery estimate for your area</p>
                <p style="margin-bottom: 20px;"><small>You will then be able to see exactly how much more to spend to get FREE shipping and save.</small></p>
            </div>
            <postcode-lookup @finished="show = false"></postcode-lookup>
        </modal-dialog>
    </div>
</template>

<script>
    import ModalDialog from '../ModalDialog.vue';

    export default {
        components: {
            ModalDialog
        },
        data() {
            return {
                show: true,
            }
        },
        created() {
            // If we have the postcode in the cookie already, don't show this modal...
            if (getCookie('postcode')) {
                this.show = false;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/Modals/PostcodeLookupModal.vue